import { SearchState } from 'src/hooks/meilisearch/types/search-state';
import { AvailableTenants } from 'src/types/responses/available-tenants';
import { MeiliSearchResponse } from 'src/types/responses/meilisearch';
import { calculatePaginationOffset } from 'src/utils/calculate-pagination-offset';
import meiliSearchApiClient from '../clients/meilisearch';
import tenantApi from '../clients/tenant';
import { TenantAvailableFloors } from '../types/response/tenant-available-floors.response';

export const fetchAvailableTenants = async (): Promise<AvailableTenants> => {
  const { data } = await tenantApi.get<AvailableTenants>('/available', {
    //? Skip the interceptor adding tenant token to URL
    skipTenantAttachment: true,
  });
  return data;
};

export const confirmTenantJoin = async () => {
  await tenantApi.post('/confirm-join');
};

export const fetchTenantAvailableFloors = async (
  tenantToken: string,
  searchState: SearchState,
  page: number,
  perPage: number,
) => {
  const { data } = await meiliSearchApiClient.post<
    MeiliSearchResponse<TenantAvailableFloors>
  >(`/indexes/Tenant-${tenantToken}/search`, {
    ...searchState,
    limit: perPage,
    offset: calculatePaginationOffset(page, perPage),
  });

  return data;
};
